<template>
  <div class="d-none">

  </div>
</template>

<script>
import NotificationService from "../services/NotificationService";
import TranslationService from "../services/TranslationService";
import ExceptionMap from "../exceptions/ExceptionMap";
import {mapState} from "vuex";

export default {
  name: "autocoupon",
  props:
      {
        template:
            {
              type: String,
              default: ''
            },
      },
  created()
  {
    const storedCouponData = JSON.parse(localStorage.getItem("automaticCoupon"));
    const now = new Date().getTime();

    if (storedCouponData)
    {
      const { coupon, timestamp } = storedCouponData;
      const isCheckoutOrBasket    = this.isCheckoutOrBasket();
      let couponCode = this.basket?.data?.couponCode;
      // Prüfe die letzte Stunde
      if (now - timestamp < 60 * 60 * 1000)
      {
        if (isCheckoutOrBasket)
        {
          if(!couponCode)
          {
            this.addCoupon(coupon);
          }
        }
      }
      else
      {
        if (!isCheckoutOrBasket)
        {
          localStorage.removeItem("automaticCoupon");
        }
      }
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const coupon = urlParams.get("addCoupon");

    if (coupon) {
      localStorage.setItem(
          "automaticCoupon",
          JSON.stringify({ coupon, timestamp: now })
      );
    }
  },
  methods: {
    async addCoupon(coupon)
    {
      try
      {
        await ceresStore.dispatch("redeemCouponCode", coupon);
        NotificationService.success(
            TranslationService.translate("Ceres::Template.couponRedeemSuccess")
        ).closeAfter(10000);
      } catch (error)
      {
        NotificationService.error(this.getCouponRedemptionErrorMessage(error)).closeAfter(10000);
      }
    },

    getCouponRedemptionErrorMessage(error)
    {
      const errorCode = error?.warn?.code || 0;
      if (errorCode > 0 && ExceptionMap.has(errorCode.toString())) {
        return TranslationService.translate("Ceres::Template." + ExceptionMap.get(errorCode.toString()));
      }
      return TranslationService.translate("Ceres::Template.couponRedeemFailure");
    },

    isCheckoutOrBasket()
    {
      const currentPath = window.location.pathname;
      const isCheckoutOrBasket = currentPath === App.urls.basket || currentPath === App.urls.checkout;
      return isCheckoutOrBasket;
    }
  },
  computed: {
    ...mapState({
      basket: state => state.basket.data,
    })
  }
};
</script>
